import { Flex, type FlexProps } from 'antd';
import classNames from 'classnames';
import type { FC, ReactNode } from 'react';
import { Text } from '../Text';
import styles from './PdfPrint.module.scss';
import { ReportSectionItem } from './ReportSectionItem';

const containSizeClass = classNames(styles.contain_size);

export type ReportSectionProps = {
  title?: ReactNode;
  wrapperStyle?: FlexProps['style'];
  containSize?: boolean;
  items: Array<{
    subtitle?: ReactNode;
    item: ReactNode;
    subtitleWrapperStyle?: FlexProps['style'];
    subtitleContentStyle?: FlexProps['style'];
    wrapperStyle?: FlexProps['style'];
    /** 使い方によってはレイアウトが崩れるパターンがあるので注意
     * https://linear.app/wise-vine/issue/PRZ-2134/bug帳票のプレビュー時は正しく表示されているもののpdf出力を行うとレイアウトが崩れている
     */
    innerStyle?: FlexProps['style'];
    isLongText?: boolean;
  }>;
};

export const ReportSection: FC<ReportSectionProps> = ({
  title,
  items,
  containSize,
  wrapperStyle,
}) => {
  return (
    <div
      style={{
        breakAfter: 'page',
      }}
    >
      <Flex
        vertical
        className={containSize ? containSizeClass : undefined}
        style={{
          gap: 2,
          boxSizing: 'border-box',
          ...wrapperStyle,
        }}
      >
        {(title && typeof title === 'string') || typeof title === 'number' ? (
          <Text text={title} />
        ) : (
          title
        )}
        {items.map((item, idx) => {
          const isLongText = item.isLongText;
          return (
            <ReportSectionItem
              // biome-ignore lint/suspicious/noArrayIndexKey: biomeをCIに仕込むために暫定的にignore。keyにユニークな値を指定するか適切な理由に書き換えること
              key={idx}
              wrapperStyle={{
                breakInside: idx === 0 ? undefined : 'avoid',
                ...item.wrapperStyle,
              }}
              title={item.subtitle}
              titleContentStyle={item.subtitleContentStyle}
              titleWrapperStyle={item.subtitleWrapperStyle}
              innerStyle={{
                ...(isLongText
                  ? {
                      display: 'flex',
                      // childrenは１つの想定でflexDirection: 'column'入れない。あるとレイアウトが崩れることがある。
                    }
                  : {}),
                ...item.innerStyle,
              }}
            >
              {item.item}
            </ReportSectionItem>
          );
        })}
      </Flex>
    </div>
  );
};
